/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import BaseDocSignElement from "@/core/modules/DocSign/data/elements/BaseDocSignElement";
import DocSignElementType from "@/core/modules/DocSign/data/DocSignElementType";

export default class DocSignTextElement extends BaseDocSignElement{


	text: string = null
	placeholder: string = "Type here"
	fontSize: number = 12
	color: string = "#000000"
	itemType: DocSignElementType = DocSignElementType.TEXT

	constructor(left: number, top: number, width: number, height: number, type: string = DocSignElementType.TEXT) {
		super(left, top, width, height, type);
	}

	isFilledIn(){
		return this.text && this.text.length > 0
	}

	shouldDeleteOnBackspace(){
		let res = !this.isFilledIn()
		console.log("shouldDeleteOnBackspace = ", res)
		return res
	}

}
